<template>
  <v-app class="rounded">
    <v-container>
      <v-card elevation="2" outlined class="mt-1">

        <v-alert class="alert-danger" v-if="getUserData.reject_text && getUserData.status == 'pending'" border="bottom" colored-border
                 type="error" elevation="2">
          <h2>دلایل رد اطلاعات در درخواست قبل</h2>
          <br/>
          <h4 v-for="(x,i) in getUserData.reject_text.split('\n')">
            {{i + 1}} : {{x}}
          </h4>
        </v-alert>


        <v-form>
          <v-row class="d-flex flex-column justify-content-center mt-2">
            <div class="company-register container">
              <v-col id="company-avatar" class="d-flex flex-column align-items-center px-0 py-0">
                <avatarUploader :pending="pending" v-model="avatar">
                  <div slot="activator">
                    <v-avatar size="150px" v-ripple v-if="getUserData != ''"
                              class="avatar grey  mb-3">
                      <!-- <span>Click to add avatar</span> -->
                      <img :src="userImageURL" alt="avatar">
                    </v-avatar>
                    <v-avatar size="150px" v-ripple v-else-if="!avatar" class="avatar grey  mb-3">
                      <!-- <span>Click to add avatar</span> -->
                      <img src="./../../../../../public/media/users/defaultAvatar.jpg" alt="avatar">
                    </v-avatar>
                    <v-avatar required size="150px" v-ripple v-else class="mb-3">
                      <img :src="avatar.imageURL" alt="avatar">
                    </v-avatar>
                  </div>
                </avatarUploader>
                <!-- <v-slide-x-transition>
                    <div v-if="avatar && saved == false">
                        <v-btn class="primary" @click="uploadImage" :loading="saving">Save Avatar
                        </v-btn>
                    </div>
                </v-slide-x-transition> -->
              </v-col>
              <v-col cols="12" id="company-name"
                     class="d-flex justify-content-center px-0 py-0 mx-0 my-0">
                <v-text-field readonly v-model="cName" class="inputs" label="نام مجموعه"
                              placeholder="نام مجموعه شما" outlined dense :rules="nameRules" requaired>
                </v-text-field>
              </v-col>
              <v-col cols="12" id="company-address" class="d-flex justify-content-center px-0 py-0">
                <v-text-field readonly v-model="cAddress" class="inputs" label="آدرس مجموعه"
                              placeholder="آدرس مجموعه شما" outlined dense prepend-inner-icon="mdi-map-marker">
                </v-text-field>
              </v-col>
              <v-col v-if="false" cols="12" id="map" class="d-flex justify-content-center">
                <v-container>
                  <v-row style="height: 500px;">
                    <l-map v-if="showMap" :zoom="zoom"
                           :center="center ? center : [32.64433, 51.65923]" :options="mapOptions"
                           @update:center="centerUpdate" @update:zoom="zoomUpdate" @click="clicked">
                      <l-tile-layer :url="url" />
                      <l-marker :lat-lng="location" v-if="location" />
                    </l-map>
                  </v-row>
                </v-container>
              </v-col>
              <v-col cols="12" xs="4" id="payment-condition " class="d-flex justify-content-center">
                <v-dialog max-width="700px" v-model="paymentDialog">
                  <template v-slot:activator="{ attrs, on }">
                    <v-btn max-width="600px" min-width="100px" width="100%" depressed
                           class="d-flex justify-content-between align-items-center" v-bind="attrs"
                           v-on="on" @click="setPayment">
                      <div class="d-flex">
                        <v-icon>mdi-credit-card-marker</v-icon>
                        <p>شرایط پرداخت</p>
                      </div>
                      <v-icon>mdi-chevron-down</v-icon>
                    </v-btn>
                  </template>
                  <v-card>
                    <div class="d-flex flex-row-reverse">
                      <v-icon medium color="red" class="mt-3 ml-3" @click="paymentDialog = false">
                        mdi-close
                      </v-icon>
                    </div>
                    <v-card-title text-h5 grey lighten-2>
                      شرایط پرداخت
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>
                        <v-form disabled v-model="valid">
                          <v-container>
                            <v-row class="d-flex flex-column align-items-center">
                              <v-col cols="12" class="d-flex justify-content-center">
                                <h2>نحوه پرداخت را انتخاب شده توسط کاربر.</h2>
                              </v-col>
                              <v-col cols="12" class="d-flex justify-content-center">
                                <v-radio-group row v-model="radioGroup">
                                  <v-radio label="نقد" color="primary" value="نقد"
                                           @click="changeRadio"></v-radio>
                                  <v-radio label="اقساط" color="primary" value="اقساط"
                                           @click="changeRadio"></v-radio>
                                  <v-radio label="سایر" color="primary" value="سایر"
                                           @click="changeRadio"></v-radio>
                                </v-radio-group>
                              </v-col>
                              <v-col>
                                <v-divider></v-divider>
                              </v-col>
                              <v-col cols="12" class="d-flex justify-content-center">
                                <v-textarea v-model="otherPaymentContent" v-if="!radio"
                                            class="inputs" outlined name="explanations"
                                            label="توضیحات" prepend-inner-icon="mdi-help">
                                </v-textarea>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-form>
                    </v-card-text>
                  </v-card>
                </v-dialog>
              </v-col>
              <v-col cols="12" xs="4" id="contact-info" class="d-flex justify-content-center">
                <v-dialog max-width="750px" v-model="contact">
                  <template v-slot:activator="{ attrs, on }">
                    <v-btn max-width="600px" min-width="100px" width="100%" depressed
                           class="d-flex justify-content-between align-items-center" v-bind="attrs"
                           v-on="on" @click="getVerified">
                      <div class="d-flex">
                        <v-icon>mdi-information</v-icon>
                        <p>اطلاعات تماس</p>
                      </div>
                      <v-icon>mdi-chevron-down</v-icon>
                    </v-btn>
                  </template>
                  <v-card>
                    <div class="d-flex flex-row-reverse">
                      <v-icon medium color="red" class="mt-3 ml-3" @click="contact = false">
                        mdi-close</v-icon>
                    </div>
                    <v-card-title grey lighten-2
                                  class="d-flex justify-content-center font-weight-bold">
                      اطلاعات تماس
                    </v-card-title>
                    <p size="20" class="text-center">کاربر این اطلاعات تماس را وارد کرده است.
                    </p>
                    <v-divider></v-divider>
                    <v-card-text>
                      <v-app>
                        <v-form disabled ref="entryForm"
                                @submit.prevent="submitInfo" v-model="valid">
                          <v-container>
                            <v-row class="d-flex flex-column align-items-start">
                              <v-col cols="12">
                                <div v-for="(cell, index) in countCell" :key="index"
                                     class="d-flex justify-content-between">
                                  <v-text-field class="contact-texts"
                                                v-model="countCell[index]" label="تلفن همراه"
                                                placeholder="تلفن همراه شما" outlined dense
                                                :rules="cellPhoneRule"
                                                prepend-inner-icon="mdi-cellphone"
                                                v-on:keypress="isNumber(countCell[index])"
                                                required>
                                    <template slot="append">
                                      <v-dialog persistent max-width="500px"
                                                v-model="phoneValidation">
                                        <template v-slot:activator="{ attrs }">
                                          <div>
                                            <p class="pt-0 mt-2">
                                              تایید شده
                                            </p>
<!--                                            <v-btn v-else-->
<!--                                                   disabled-->
<!--                                                   deppresed dense-->
<!--                                                   class="btn-get-code"-->
<!--                                                   @click="codeRequest(index)"-->
<!--                                                   v-bind="attrs">-->
<!--                                              <v-icon>mdi-cellphone-->
<!--                                              </v-icon>-->
<!--                                              <span>کد اعتبارسنجی</span>-->
<!--                                            </v-btn>-->
                                          </div>
                                          <!-- <span v-else color="green">ثبت شد.</span> -->
                                        </template>
                                        <v-card>
                                          <v-card-title>کد اعتبارسنجی
                                          </v-card-title>
                                          <v-card-text>
                                            <p size="30">لطفا کد
                                              اعتبارسنجی
                                              دریافتی در موبایل خود را
                                              وارد کنید.</p>
                                            <v-text-field outlined dense
                                                          label="کد اعتبارسنجی"
                                                          placeholder="کد اعتبارسنجی را وارد کنید"
                                                          v-model="code"
                                                          v-on:keypress="codeIsNumber(code)">
                                            </v-text-field>
                                          </v-card-text>
                                          <div
                                              class="d-flex justify-content-between">
                                            <v-btn class="btn-validation"
                                                   @click="submitPhone()">
                                              <v-icon>
                                                mdi-clipboard-check
                                              </v-icon>
                                              <span>اعتبارسنجی</span>
                                            </v-btn>
                                            <v-btn class="btn-back"
                                                   @click="phoneClose">
                                              <v-icon>
                                                mdi-reply-all
                                              </v-icon>
                                              <span>بازگشت</span>
                                            </v-btn>
                                          </div>
                                        </v-card>
                                      </v-dialog>
                                    </template>
<!--                                    <template slot="append-outer">-->
<!--                                      <div class="plus-minus d-flex">-->
<!--                                        <v-btn class="btn-add-with-text"-->
<!--                                               @click="addCell()">-->
<!--                                          <v-icon disabled>-->
<!--                                            mdi-plus-->
<!--                                          </v-icon>-->
<!--                                        </v-btn>-->
<!--                                        <v-btn v-if="countCell.length > 1"-->
<!--                                               class="btn-dec-with-text"-->
<!--                                               @click="removeCell(index)">-->
<!--                                          <v-icon disabled>-->
<!--                                            mdi-minus-->
<!--                                          </v-icon>-->
<!--                                        </v-btn>-->
<!--                                      </div>-->
<!--                                    </template>-->
                                  </v-text-field>
                                  <!-- <p
                                              v-if="phones.indexOf(countCell[index]) != -1">تایید
                                              شده</p> -->

                                </div>
                              </v-col>
                              <v-col cols="12">
                                <div v-for="(item, index) in countPhone" :key="index">
                                  <v-text-field v-model="countPhone[index]"
                                                label="تلفن ثابت (با پیش شماره)"
                                                placeholder="تلفن ثابت شما" outlined dense
                                                prepend-inner-icon="mdi-phone"
                                                :rules="telePhoneRules"
                                                v-on:keypress="isNumber(countPhone[index])">
<!--                                    <template slot="append-outer">-->
<!--                                      <div class="plus-minus d-flex">-->
<!--                                        <v-btn class="btn-add-with-text"-->
<!--                                               @click="addPhone">-->
<!--                                          <v-icon disabled>-->
<!--                                            mdi-plus-->
<!--                                          </v-icon>-->
<!--                                        </v-btn>-->
<!--                                        <v-btn v-if="countPhone.length > 1"-->
<!--                                               class="btn-dec-with-text"-->
<!--                                               @click="removePhone(index)">-->
<!--                                          <v-icon disabled>-->
<!--                                            mdi-minus-->
<!--                                          </v-icon>-->
<!--                                        </v-btn>-->
<!--                                      </div>-->
<!--                                    </template>-->
                                  </v-text-field>
                                </div>
                              </v-col>
                              <v-col cols="12">
                                <div v-for="(item, index) in countMail" :key="index"
                                     class=" d-flex justify-content-between">
                                  <v-text-field v-model="countMail[index]"
                                                label="ایمیل" placeholder="ایمیل شما" outlined
                                                dense prepend-inner-icon="mdi-email"
                                                :rules="emailRules">
                                    <template slot="append">
                                      <v-dialog persistent max-width="500px"
                                                v-model="mailValidation">
                                        <template v-slot:activator="{ attrs }">
                                          <div>
                                            <p v-if="phones.indexOf(countMail[index]) != -1"
                                               class="pt-0 mt-2">
                                              تایید شده
                                            </p>
<!--                                            <v-btn v-else-->
<!--                                                   disabled-->
<!--                                                   deppresed dense-->
<!--                                                   class="email-btn btn-get-code"-->
<!--                                                   @click="mailRequest(index)"-->
<!--                                                   v-bind="attrs">-->
<!--                                              <v-icon>-->
<!--                                                mdi-email-->
<!--                                              </v-icon>-->
<!--                                              <span>ایمیل-->
<!--                                                                                                اعتبارسنجی</span>-->
<!--                                            </v-btn>-->
                                          </div>
                                        </template>
                                        <v-card>
                                          <v-card-title>کد اعتبارسنجی
                                          </v-card-title>
                                          <v-card-text>
                                            <p size="20">لطفا کد
                                              اعتبارسنجی
                                              دریافتی در ایمیل خود را
                                              وارد کنید.</p>
                                            <v-text-field outlined dense
                                                          label="کد اعتبارسنجی"
                                                          placeholder="کد اعتبارسنجی را وارد کنید"
                                                          v-model="code"
                                                          v-on:keypress="codeIsNumber(code)">
                                            </v-text-field>
                                          </v-card-text>
                                          <div
                                              class="d-flex justify-content-between">
                                            <v-btn class="btn-validation"
                                                   @click="submitMail()">
                                              <v-icon>
                                                mdi-clipboard-check
                                              </v-icon>
                                              <span>اعتبارسنجی</span>
                                            </v-btn>
                                            <v-btn class="btn-back"
                                                   @click="mailClose">
                                              <v-icon>
                                                mdi-reply-all
                                              </v-icon>
                                              <span>بازگشت</span>
                                            </v-btn>
                                          </div>
                                        </v-card>
                                      </v-dialog>
                                    </template>
<!--                                    <template slot="append-outer">-->
<!--                                      <div class="plus-minus d-flex">-->
<!--                                        <v-btn class="btn-add-with-text"-->
<!--                                               @click="addMail">-->
<!--                                          <v-icon disabled>-->
<!--                                            mdi-plus-->
<!--                                          </v-icon>-->
<!--                                        </v-btn>-->
<!--                                        <v-btn v-if="countMail.length > 1"-->
<!--                                               class="btn-dec-with-text"-->
<!--                                               @click="removeMail(index)">-->
<!--                                          <v-icon disabled>-->
<!--                                            mdi-minus-->
<!--                                          </v-icon>-->
<!--                                        </v-btn>-->
<!--                                      </div>-->
<!--                                    </template>-->
                                  </v-text-field>
                                </div>
                              </v-col>
                              <v-col cols="12">
                                <div v-for="(item, index) in countWeb" :key="index">
                                  <v-text-field v-model="countWeb[index]"
                                                label="وبسایت" placeholder="آدرس وبسایت شما"
                                                outlined dense prepend-inner-icon="mdi-web"
                                                :rules="webSiteRules">
<!--                                    <template slot="append-outer">-->
<!--                                      <div class="plus-minus d-flex">-->
<!--                                        <v-btn class="btn-add-with-text"-->
<!--                                               @click="addWeb">-->
<!--                                          <v-icon disabled>-->
<!--                                            mdi-plus-->
<!--                                          </v-icon>-->
<!--                                        </v-btn>-->
<!--                                        <v-btn v-if="countWeb.length > 1"-->
<!--                                               class="btn-dec-with-text"-->
<!--                                               @click="removeWeb(index)">-->
<!--                                          <v-icon disabled>-->
<!--                                            mdi-minus-->
<!--                                          </v-icon>-->
<!--                                        </v-btn>-->
<!--                                      </div>-->
<!--                                    </template>-->
                                  </v-text-field>
                                </div>
                              </v-col>
                              <v-col cols="12" class="media">
                                <v-card flat class="icon-card">
                                  <v-card-title>
                                    <v-icon right>mdi-dialpad</v-icon>
                                    <span>شبکه های اجتماعی</span>
                                  </v-card-title>
                                  <v-card-text>
                                    <div v-for="(icon, l) in icons" :key="l"
                                         class="btn btn-icon flex-row justify-content-center mt-4">
                                      <v-tooltip top>
                                        <template
                                            v-slot:activator="{ on, attrs }">
                                          <v-hover v-slot="{ hover }">
                                            <i @click="addMediaInput(l)"
                                               v-bind="attrs" v-on="on"
                                               :class="icon.name"
                                               :style="{ 'background': hover ? icon.color : '' }"
                                               class="icon-i"></i>
                                          </v-hover>
                                        </template>
                                        <span>{{ icon.label }}</span>
                                      </v-tooltip>
                                    </div>
                                  </v-card-text>
                                  <div v-for="(iconTextField, u) in iconTextFields"
                                       :key="u">
                                    <v-text-field v-if="getUserData == ''"
                                                  v-model="iconTextField.dataInput"
                                                  :label="iconTextField.label"
                                                  :placeholder="iconTextField.placeholder"
                                                  outlined dense
                                                  :prepend-inner-icon="iconTextField.mdi">
<!--                                      <template slot="append-outer">-->
<!--                                        <div class="plus-minus d-flex">-->
<!--                                          <v-btn class="btn-add-with-text"-->
<!--                                                 @click="addTextMediaInput(iconTextField.label)">-->
<!--                                            <v-icon disabled>-->
<!--                                              mdi-plus-->
<!--                                            </v-icon>-->
<!--                                          </v-btn>-->
<!--                                          <v-btn class="btn-dec-with-text"-->
<!--                                                 @click="removeIconInput(u)">-->
<!--                                            <v-icon disabled>-->
<!--                                              mdi-minus-->
<!--                                            </v-icon>-->
<!--                                          </v-btn>-->
<!--                                        </div>-->
<!--                                      </template>-->
                                    </v-text-field>
                                    <v-text-field v-else
                                                  v-model="iconTextField.model"
                                                  :label="iconTextField.label"
                                                  :placeholder="iconTextField.placeholder"
                                                  outlined dense
                                                  :prepend-inner-icon="iconTextField.mdi">
<!--                                      <template slot="append-outer">-->
<!--                                        <div class="plus-minus d-flex">-->
<!--                                          <v-btn class="btn-add-with-text"-->
<!--                                                 @click="addTextMediaInput(iconTextField.label)">-->
<!--                                            <v-icon disabled>-->
<!--                                              mdi-plus-->
<!--                                            </v-icon>-->
<!--                                          </v-btn>-->
<!--                                          <v-btn class="btn-dec-with-text"-->
<!--                                                 @click="removeIconInput(u)">-->
<!--                                            <v-icon disabled>-->
<!--                                              mdi-minus-->
<!--                                            </v-icon>-->
<!--                                          </v-btn>-->
<!--                                        </div>-->
<!--                                      </template>-->
                                    </v-text-field>
                                  </div>
                                </v-card>
                              </v-col>
                              <v-col class="d-flex justify-content-center" cols="12">


                              </v-col>
                            </v-row>
                          </v-container>
                        </v-form>
                      </v-app>
                    </v-card-text>
                  </v-card>
                </v-dialog>
              </v-col>
<!--              <v-col cols="12" id="upload-docs" class="uploader d-flex justify-content-center">-->
<!--                <a target="_blank" :href="appUrl + '/storage/' + (getUserData.billboard_documents ? getUserData.billboard_documents[0] : '')">-->
<!--                  <v-btn color="indigo" outlined class="text-white col-md-12 inputs">-->
<!--                    <v-icon>mdi-briefcase-upload</v-icon>-->
<!--                    دانلود مدارک-->
<!--                  </v-btn>-->
<!--                </a>-->
<!--                <input ref="uploader" class="d-none" type="file" @change="onFileChanged">-->
<!--              </v-col>-->
              <v-col cols="12" id="about-us" class="d-flex justify-content-center">
                <v-textarea readonly v-model="aboutUs" class="inputs" outlined
                            name="about-us" label="درباره ما" prepend-inner-icon="mdi-account-tie">
                </v-textarea>
              </v-col>
<!--              <v-col cols="12" id="submitForm" class="d-flex justify-content-center">-->
<!--                <v-btn v-if="formSubmitted" disabled x-large class="submit-btn"-->
<!--                       @click="submitForm">-->
<!--                  <v-icon>mdi-bookmark</v-icon>-->
<!--                  <span>ثبت</span>-->
<!--                </v-btn>-->
<!--                <v-btn v-else disabled x-large class="submit-btn" @click="submitForm">-->
<!--                  <v-icon>mdi-bookmark</v-icon>-->
<!--                  <span>ثبت</span>-->
<!--                </v-btn>-->
<!--              </v-col>-->

              <v-row class="justify-content-center mb-2" v-if="getUserData.status == 'pending'">
                <v-btn class="btn-accept" rounded @click="changeStatus('accept')">
                  <v-icon size="25">mdi-check</v-icon>
                  تایید
                </v-btn>
                <v-btn class="btn-delete" rounded @click="rejectDialog = true ">
                  <v-icon size="25">mdi-close</v-icon>
                  رد
                </v-btn>
              </v-row>
              <v-row v-else class="justify-content-center mb-2 align-items-center">
                <v-alert
                    class="mb-0"
                    :type="getUserData.status == 'reject'? 'error' : 'success'"
                >

                  وضعیت فعلی
                  `{{getUserData.status == 'reject'? 'رد' : 'تایید'}}`

                </v-alert>

                <v-btn class="btn-edit py-2" rounded @click="getUserData.status = 'pending' ">
                  <v-icon size="25">mdi-pencil</v-icon>
                  تغیر وضعیت
                </v-btn>
              </v-row>

            </div>


            <v-dialog
                v-model="rejectDialog"
                scrollable
                max-width="400px"
                max-height="150px"
            >

              <v-card>
                <v-card-title>رد اطلاعات</v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                  <v-row>
                    <v-textarea
                        v-model="rejectText"
                        label="متن پیام رد"
                        :rules="[
                            v => !!(v ? v :  '').trim().length  > 2  || 'متن پیام رد باید بیشتر از 2 کاراکتر باشد.',
                        ]"
                        required
                        outlined
                        class="mt-5"
                    >
                    </v-textarea>
                  </v-row>


                  <v-row class="mt-10">
                    <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">
                      <v-btn
                          block
                          class="btn-record"
                          :disabled="(rejectText ? rejectText : '').trim().length  <= 2"
                          @click="rejectDialog = false; changeStatus('reject')"
                      >
                        <v-icon>
                          mdi-close
                        </v-icon>
                        <b>رد</b>

                      </v-btn>
                    </v-flex >
                    <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">
                      <v-btn
                          class="btn-back"
                          block
                          @click="rejectDialog = false"
                      >
                        <v-icon>
                          mdi-close
                        </v-icon>
                        <b>انصراف</b>
                      </v-btn>
                    </v-flex>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-dialog>

          </v-row>
        </v-form>
      </v-card>
    </v-container>
  </v-app>
</template>
<script>
import { latLng } from "leaflet";
import avatarUploader from "@/view/pages/bilboard/avatarUploader.vue"

export default {
  name: 'company-register',
  components: { avatarUploader },
  data() {
    return {
      appUrl : process.env.VUE_APP_API_URL,
      rejectText : "",
      rejectDialog: false,
      // userImageURL: '',
      userImageFile: '',
      paymentDialog: false,
      code: '',
      isEmpty: true,
      radioGroup: 'نقد',
      radio: true,
      phoneValidation: false,
      mailValidation: false,
      lastValidation: true,
      cName: '',
      cAddress: '',
      paymentType: '',
      otherPaymentContent: '',
      paymentContent: '',
      codeSentNum: '',
      codeSentEmail: '',
      aboutUs: '',
      iconTextFields: [],
      userInfo: [],
      phones: [],
      getUserData: [],
      validationBoolean: [
        {
          number: '',
          verifyStatus: ''
        }
      ],
      emailValidationBoolean: [
        {
          email: '',
          verifyStatus: ''
        }
      ],
      isValid: true,
      emailIsValid: true,
      icons: [
        { name: "flaticon-instagram-logo", label: "Instagram", mdi: "mdi-instagram", dataInput: "instaAccount", placeholder: "اکانت اینستاگرام", color: "radial-gradient(circle at 30% 107%, #fdf497 0%, #fdf497 5%, #fd5949 45%,#d6249f 60%,#285AEB 90%" },
        { name: "flaticon2-telegram-logo", label: "Telegram", mdi: "mdi-telegram", dataInput: "teleAccount", placeholder: "اکانت تلگرام", color: "linear-gradient(120deg, #0088CC, #FFFFFF)" },
        { name: "flaticon-whatsapp", label: "Whatsapp", mdi: "mdi-whatsapp", dataInput: "whatsAccount", placeholder: "اکانت واتس اپ", color: "linear-gradient(45deg, #E5FFCC, #1EBEA5, #00E676, #D0E9EA, #EDF8F5, #FFFFFF)" },
        { name: "flaticon-linkedin-logo", label: "Linkedin", mdi: "mdi-linkedin", dataInput: "linkAccount", placeholder: "اکانت لینکدین", color: "linear-gradient(45deg, #0077B5, #000000, #313335, #86888A, #CACCCE, #00A0DC)" },
        { name: "flaticon-skype-logo", label: "Skype", mdi: "mdi-skype", dataInput: "skypeAccount", placeholder: "اکانت اسکایپ", color: "linear-gradient(120deg, #00AFF0, #FFFFFF)" },
        { name: "flaticon-twitter-logo", label: "Twitter", mdi: "mdi-twitter", dataInput: "twitAccount", placeholder: "اکانت توییتر", color: "linear-gradient(45deg, #66757F, #00ACEE, #36D8FF, #F5F8FA, #FFFFFF)" },
        { name: "flaticon-facebook-letter-logo", label: "Facebook", mdi: "mdi-facebook", dataInput: "faceAccount", placeholder: "اکانت فیسبوک", color: "linear-gradient(120deg, #3B5998, #FFFFFF)" },
        { name: "flaticon-youtube", label: "Youtube", mdi: "mdi-youtube", dataInput: "youAccount", placeholder: "اکانت یوتیوب", color: "linear-gradient(120deg, #FF0000, #282828)" },
      ],
      countCell: [
        ""
      ],
      countPhone: [
        ""
      ],
      countMail: [
        ""
      ],
      countWeb: [
        ""
      ],
      avatar: null,
      saving: false,
      saved: false,
      location: null,
      contact: false,
      payment: false,
      valid: false,
      valid2: false,
      isSelecting: false,
      selectedFile: null,
      zoom: 13,
      center: latLng(32.64433, 51.65923),
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      currentZoom: 11.5,
      currentCenter: latLng(47.41322, -1.219482),
      mapOptions: {
        zoomSnap: 0.5
      },
      showMap: true,
      //rules
      nameRules: [
        v => !!v || 'این فیلد ضروری است',
        v => !v || v.length >= 4 || 'حداقل ۴ کاراکتر',
        v => !v || v.length <= 100 || 'حداکثر ۱۰۰ کاراکتر',
        v => !v || /(?!^\d+$)^[ آابپتثجچحخدذرزژسشصضطظعغفقکگلمنوهیئ123456789۱۲۳۴۵۶۷۸۹۰0\s]+$/.test(v) || "نام باید تنها شامل اعداد فارسی و حروف باشد"
      ],
      documentsRules: [
        value => !value || value.size < 1000000 || 'حجم تصویر نباید بیشتر از ۱ مگابایت باشد!',
      ],
      emailRules: [
        v => !v || /.+@.+\..+/.test(v) || " مثال: example@test.com فرمت ایمیل معتبر نیست!"
      ],
      cellPhoneRule: [
        v => !!v || "این فیلد اجباری است.",
        v => !v || v.length < 12 || "شماره همراه وارد شده صحیح نیست!",
        v => this.validatePhone(v) || "شماره موبایل باید با ۰۹ شروع شود."
      ],
      telePhoneRules: [
        v => !v || v.length < 12 || "شماره تلفن ثابت وارد شده صحیح نیست!"
      ],
      webSiteRules: [
        v => !v || /https?:[0-9]*\/\/[\w!?/\+\-_~=;\.,*&@#$%\(\)\'\[\]]+/.test(v) || "فرمت وبسایت صحیح نیست. مثال: http://example.com یا https://example.com"
      ],
      envAddress: '',
      userImageURL: '',
      getPaymentTerms: '',
      pending: true,
      oneTime: true,
      formSubmitted: true,
    }
  },
  created() {
    this.formSubmitted = true
    this.$modal.showLoading();
    this.init();

  },
  watch: {
    avatar: {
      handler: function () {
        this.saved = false
      },
      deep: true
    },

  },
  methods: {
    translateStatus(status){
      switch (status) {
        case "accept":
          return "تایید"

        case "reject":
          return "رد"

        case "pending" :
          return "در انتظار تایید";

        default:
          return status
      }
    },
    async changeStatus(status){
      let text = this.translateStatus(status);

      if (this.$modal.yesNo('ایا از تغیر وضعیت به ' + text + "مطمعین هستید")){
        this.$modal.showLoading();
        let data = {
          "status": status
        };

        if (status == 'reject'){
          data.reject_text = this.rejectText;
        }

        this.requestApiPut('userInfo/' + this.$route.params.id, data)
        .then((res)=>{
          this.init();
          this.$toast.success("تغیرات با موفقیت اعمال شد");
        }).catch((res)=>{
          this.$toast.error('خطایی رخ داده است');
        }).finally(()=>{
          this.$modal.hideLoading();
        })
      }
    },
    init(){
      this.requestApiGet('userInfo/list/' + this.$route.params.id)
          .then(({ data }) => {
            this.$modal.hideLoading()
            this.getUserData = data.data
            this.fillData();
            console.log(this.getUserData)
            console.log(this.getUserData)
            this.isPending()
          })
          .catch((err) => {
            this.$modal.hideLoading()
            this.$modal.error('خطا در اتصال به دیتابیس')
            console.log(err)

          })
    },

    fillData(){
      this.cName = this.getUserData.collection_name
      this.cAddress = this.getUserData.collection_address
      this.aboutUs = this.getUserData.about_us
      this.userImageFile = this.getUserData.about_logo
      // this.envAddress = process.env.VUE_APP_API_URL
      this.userImageURL = process.env.VUE_APP_API_URL + '/storage/' + this.userImageFile
      this.getPaymentTerms = this.getUserData.payment_terms
    },
    isPending() {
      if (this.getUserData.status == 'pending') {
        this.pending = false
        console.log(this.pending)
      }
    },
    goHome() {
      this.$router.push('/home')
    },
    setPayment() {
      if (this.getUserData != '') {
        if (this.getPaymentTerms == 'نقد') {
          this.radioGroup = "نقد"
        } else if (this.getPaymentTerms == 'اقساط') {
          this.radioGroup = "اقساط"
        } else {
          this.radioGroup = "سایر"
          this.radio = false
          this.otherPaymentContent = this.getPaymentTerms
        }
      }
    },
    checkValid() {
      for (let i = 0; i < this.validationBoolean.length; i++) {
        if (this.validationBoolean[i].verifyStatus == false) {
          this.isValid = false
        } else {
          this.isValid = true
        }
      }
      console.log('btn must be' + this.isValid)
    },
    checkEmailValid() {
      for (let i = 0; i < this.emailValidationBoolean.length; i++) {
        if (this.emailValidationBoolean[i].verifyStatus == false) {
          this.emailIsValid = false
        } else {
          this.emailIsValid = true
        }
      }
      console.log('btn must be' + this.emailIsValid)
    },
    getVerified() {
      //  this.requestApiGet('contact')
      //     .then(res => {
      //         let response = res.data.data
      //         if (response) {
      //             this.phones = response.map((a) => {
      //                 return a.contact;
      //             })
      //         }
      //         this.phones.push(this.user.phone)

      //     })
      //     .catch(err => {
      //         console.log(err)
      //     })
      let telePhone = []
      let phone = []
      let mail = []
      let site = []
      let insta = []
      let telegram = []
      let whatsapp = []
      let linkdin = []
      let skype = []
      let twitter = []
      let facebook = []
      let youtube = []
      if (this.user.phone != '' && this.getUserData == '') {
        this.countCell[0] = this.user.phone
      }
      if (this.user.email != '' && this.getUserData == '') {
        this.countMail[0] = this.user.email
      }
      if (this.getUserData != '' && this.oneTime == true) {
        for (let i = 0; i < this.getUserData.contacts.length; i++) {
          if (this.getUserData.contacts[i].type == 'telephone') {
            // this.findVerified(this.getUserData.contacts[i].value)
            // console.log(this.getUserData.contacts[i].value)
            telePhone.push({
              cellNumber: this.getUserData.contacts[i].value
            })
          }
          if (this.getUserData.contacts[i].type == 'phone') {
            phone.push({
              phoneNumber: this.getUserData.contacts[i].value
            })
          }
          if (this.getUserData.contacts[i].type == 'email') {
            mail.push({
              email: this.getUserData.contacts[i].value
            })
          }
          if (this.getUserData.contacts[i].type == 'site') {
            site.push({
              site: this.getUserData.contacts[i].value
            })
          }
          if (this.getUserData.contacts[i].type == 'instagram') {
            insta.push({
              instaValue: this.getUserData.contacts[i].value
            })
          }
          if (this.getUserData.contacts[i].type == 'telegram') {
            telegram.push({
              telegram: this.getUserData.contacts[i].value
            })
          }
          if (this.getUserData.contacts[i].type == 'whatsapp') {
            whatsapp.push({
              whatsapp: this.getUserData.contacts[i].value
            })
          }
          if (this.getUserData.contacts[i].type == 'linkdin') {
            linkdin.push({
              linkdin: this.getUserData.contacts[i].value
            })
          }
          if (this.getUserData.contacts[i].type == 'skype') {
            skype.push({
              skype: this.getUserData.contacts[i].value
            })
          }
          if (this.getUserData.contacts[i].type == 'twitter') {
            twitter.push({
              twitter: this.getUserData.contacts[i].value
            })
          }
          if (this.getUserData.contacts[i].type == 'facebook') {
            facebook.push({
              facebook: this.getUserData.contacts[i].value
            })
          }
          if (this.getUserData.contacts[i].type == 'youtube') {
            youtube.push({
              youtube: this.getUserData.contacts[i].value
            })
          }
        }
        for (let i = 0; i < telePhone.length; i++) {
          this.countCell[i] = telePhone[i].cellNumber
        }
        for (let i = 0; i < phone.length; i++) {
          this.countPhone[i] = phone[i].phoneNumber
        }
        for (let i = 0; i < mail.length; i++) {
          this.countMail[i] = mail[i].email
        }
        for (let i = 0; i < site.length; i++) {
          this.countWeb[i] = site[i].site
        }
        for (let i = 0; i < insta.length; i++) {
          let instagramValue = insta[i].instaValue
          this.addUserSocial('Instagram', instagramValue)
        }
        for (let i = 0; i < telegram.length; i++) {
          let telegramValue = telegram[i].telegram
          this.addUserSocial('Telegram', telegramValue)
        }
        for (let i = 0; i < whatsapp.length; i++) {
          let whatsappValue = whatsapp[i].whatsapp
          this.addUserSocial('Whatsapp', whatsappValue)
        }
        for (let i = 0; i < linkdin.length; i++) {
          let linkdinValue = linkdin[i].linkdin
          this.addUserSocial('Linkdin', linkdinValue)
        }
        for (let i = 0; i < skype.length; i++) {
          let skypeValue = skype[i].skype
          this.addUserSocial('Skype', skypeValue)
        }
        for (let i = 0; i < skype.length; i++) {
          let skypeValue = skype[i].skype
          this.addUserSocial('Skype', skypeValue)
        }
        for (let i = 0; i < twitter.length; i++) {
          let twitterValue = twitter[i].twitter
          this.addUserSocial('Twitter', twitterValue)
        }
        for (let i = 0; i < facebook.length; i++) {
          let facebookValue = facebook[i].facebook
          this.addUserSocial('Facebook', facebookValue)
        }
        for (let i = 0; i < youtube.length; i++) {
          let youtubeValue = youtube[i].youtube
          this.addUserSocial('Youtube', youtubeValue)
        }
        this.oneTime = false
      }
    },
    // findVerified(number) {
    //     for(let j = 0; j < this.phones.length; j++) {
    //         if(number == this.phones[j]) {
    //             this.isVerified = true
    //         }
    //     }
    // },
    phoneClose() {
      this.phoneValidation = false
    },
    mailClose() {
      this.mailValidation = false
    },
    changeRadio() {
      if (this.radioGroup == 'نقد' || this.radioGroup == 'اقساط') {
        this.radio = true
      } else {
        this.radio = false
      }
    },
    codeRequest(index) {
      if (this.countCell[0] == '') {
        this.$toast.error('شماره تلفن همراه خود را وارد کنید.')
        this.phoneValidation = false
      } else {
        this.phoneValidation = true
      }
      for (let i = 0; i < this.phones.length; i++) {
        if (this.phones[i] == this.countCell[index]) {
          this.$toast.warning('این شماره نیاز به اعتبارسنجی ندارد.')
          this.phoneValidation = false
        }
      }
      if (this.validatePhone(this.countCell[index])) {
        if (this.user.phone == this.countCell[index]) {
          this.phoneValidation = false
          this.$toast.warning('این شماره نیاز به اعتبارسنجی ندارد.')
        } else {
          this.requestApiPost('contact', {
            type: 'phone',
            contact: this.countCell[index]
          })
              .then((res) => {
                console.log(res)
                this.codeSentNum = this.countCell[index]
              })
              .catch(({ response }) => {
                console.log(response)
                this.$toast.error(response.message)
              })
        }
      } else if (this.countCell[index] != '') {
        this.phoneValidation = false
        this.$toast.error('اطلاعات را صحیح وارد کنید.')
      }
    },
    mailRequest(index) {
      if (this.countMail[0] == '') {
        this.$toast.error('ایمیل خود را وارد کنید.')
        this.mailValidation = false
      } else {
        this.mailValidation = true
      }
      for (let i = 0; i < this.phones.length; i++) {
        if (this.phones[i] == this.countMail[index]) {
          this.$toast.warning('این ایمیل نیاز به اعتبارسنجی ندارد.')
          this.mailValidation = false
        }
      }
      if (/.+@.+\..+/.test(this.countMail[index])) {
        this.requestApiPost('contact', {
          type: 'email',
          contact: this.countMail[index]
        })
            .then((res) => {
              console.log(res)
              this.codeSentEmail = this.countMail[index]
            })
            .catch(({ response }) => console.log(response))
      } else if (this.countMail[index] != '') {
        this.mailValidation = false
        this.$toast.error('اطلاعات را صحیح وارد کنید.')
      }
    },
    submitPhone() {
      let verified = false
      if (this.code == '') {
        this.$toast.error('لطفا کد را وارد کنید.')
      } else if (this.code.length < 6) {
        console.log(this.code.length)
        this.$toast.error('کد وارد شده اشتباه است.')
      } else {
        this.requestApiPut(`contact?contact=${this.codeSentNum}&type=phone&code=${this.code}`)
            .then(res => {
              console.log(res)
              if (res.status == 200) {
                verified = true
                this.phoneValidation = false
                this.$toast.success('اعتبارسنجی با موفقیت انجام شد.')
                this.phones.push(this.codeSentNum)
                this.code = ''
              } else {
                verified = false
                this.$toast.error('اعتبارسنجی موفقیت آمیز نبود.')
                this.phoneValidation = false
                this.code = ''
              }
              for (let i = 0; i < this.validationBoolean.length; i++) {
                if (this.validationBoolean[0].number == '') {
                  this.validationBoolean[0].number = this.codeSentNum
                  this.validationBoolean[0].verifyStatus = verified
                } else if (this.validationBoolean[i].number == this.codeSentNum) {
                  this.validationBoolean[i].number = this.codeSentNum
                  this.validationBoolean[i].verifyStatus = verified
                  // this.validationBoolean.pop()
                  console.log(this.validationBoolean)
                } else if (this.validationBoolean[i].number != this.codeSentNum && i == this.validationBoolean.length - 1) {
                  this.validationBoolean.push({
                    number: this.codeSentNum,
                    verifyStatus: verified
                  })
                }
              }
              this.checkValid()
            })
            .catch(err => console.log(err))
      }
    },
    submitMail() {
      let verified = false
      if (this.code == '') {
        this.$toast.error('لطفا کد را وارد کنید.')
      } else if (this.code.length < 6) {
        this.$toast.error('کد وارد شده اشتباه است.')
      } else {
        console.log(this.codeSentEmail)
        this.requestApiPut(`contact?contact=${this.codeSentEmail}&type=email&code=${this.code}`)
            .then(res => {
              console.log(res)
              if (res.status == 200) {
                verified = true
                this.mailValidation = false
                this.$toast.success('اعتبارسنجی با موفقیت انجام شد.')
                this.phones.push(this.codeSentEmail)
                this.code = ''
              } else {
                verified = false
                this.$toast.error('اعتبارسنجی موفقیت آمیز نبود.')
                this.mailValidation = false
                this.code = ''
              }
              for (let i = 0; i < this.emailValidationBoolean.length; i++) {
                if (this.emailValidationBoolean[0].email == '') {
                  this.emailValidationBoolean[0].email = this.codeSentEmail
                  this.emailValidationBoolean[0].verifyStatus = verified
                } else if (this.emailValidationBoolean[i].email == this.codeSentEmail) {
                  this.emailValidationBoolean[i].email = this.codeSentEmail
                  this.emailValidationBoolean[i].verifyStatus = verified
                  console.log(this.emailValidationBoolean)
                } else if (this.emailValidationBoolean[i].email != this.codeSentEmail && i == this.emailValidationBoolean.length - 1) {
                  this.emailValidationBoolean.push({
                    email: this.codeSentEmail,
                    verifyStatus: verified
                  })
                }
              }
            })
            .catch(err => console.log(err))
      }
    },
    sendPayment() {
      let paymentKind = this.radioGroup
      if (paymentKind == 'نقد') {
        this.paymentContent = 'نقد'
      } else if (paymentKind == 'اقساط') {
        this.paymentContent = 'اقساط'
      } else {
        this.paymentContent = this.otherPaymentContent
      }
      this.paymentDialog = false
    },
    addCell() {
      this.countCell.push("")
    },
    addPhone() {
      this.countPhone.push("")
    },
    addMail() {
      this.countMail.push("")
    },
    addWeb() {
      this.countWeb.push("")
    },
    // uploadImage() {
    //     this.saving = true
    //     setTimeout(() => this.savedAvatar(), 1000)
    // },
    // savedAvatar() {
    //     this.saving = false
    //     this.saved = true
    // },
    zoomUpdate(zoom) {
      this.currentZoom = zoom;
    },
    centerUpdate(center) {
      this.currentCenter = center;
    },
    clicked(e) {
      console.log(e.latlng);
      this.location = e.latlng;
    },
    isNumber: function (cellNum) {
      var evt = (evt) ? evt : window.event;
      var cellNumber = cellNum.length + 1
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57) && (charCode < 1776 || charCode > 1785)) || cellNumber > 11) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    codeIsNumber: function (code) {
      var evt = (evt) ? evt : window.event;
      var codeRecived = code.length + 1
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57) && (charCode < 1776 || charCode > 1785)) || codeRecived > 6) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    // changePayment() {
    //     if (this.payment) {
    //         this.paymentType = 'اقساط'
    //     } else {
    //         this.paymentType = 'نقد'
    //     }
    //     return console.log(this.paymentType)
    // },
    removeCell(index) {
      this.countCell.splice(index, 1)
    },
    removePhone(index) {
      this.countPhone.splice(index, 1)
    },
    removeMail(index) {
      this.countMail.splice(index, 1)
    },
    removeWeb(index) {
      this.countWeb.splice(index, 1)
    },
    addMediaInput(item) {
      if (this.pending == true)
        for (let c = 0; c <= this.icons.length; c++) {
          if (c === item) {
            this.iconTextFields.push({
              label: this.icons[c].label,
              mdi: this.icons[c].mdi,
              placeholder: this.icons[c].placeholder,
              model: this.icons[c].dataInput,
              color: this.icons[c].color
            })
            console.log(this.icons[c].dataInput);
          }
        }
    },
    addUserSocial(item, value) {
      for (let c = 0; c < this.icons.length; c++) {
        console.log(value)
        if (this.icons[c].label == item) {

          this.iconTextFields.push({
            label: this.icons[c].label,
            mdi: this.icons[c].mdi,
            placeholder: this.icons[c].placeholder,
            model: value,
            color: this.icons[c].color
          })

        }
      }
    },
    addTextMediaInput(label) {
      console.log(label)
      for (let y = 0; y < this.icons.length; y++) {
        if (label == this.icons[y].label) {
          this.iconTextFields.push({
            label: this.icons[y].label,
            mdi: this.icons[y].mdi,
            placeholder: this.icons[y].placeholder,
            model: this.icons[y].model,
            color: this.icons[y].color
          })
        }
      }
    },
    removeIconInput(index) {
      this.iconTextFields.splice(index, 1)
    },
    handleFileImport() {
      this.isSelecting = true;
      // After obtaining the focus when closing the FilePicker, return the button state to normal
      window.addEventListener('focus', () => {
        this.isSelecting = false
      }, { once: true });
      // Trigger click on the FileInput
      this.$refs.uploader.click();
    },
    onFileChanged(e) {
      this.selectedFile = e.target.files[0];
      // Do whatever you need with the file, liek reading it with FileReader
    },
    submitInfo() {
      let counter = 0
      for (let i = 0; i < this.countCell.length; i++) {
        if (this.countCell[i] !== "") {
          counter = counter + 1
        }
      }
      for (let i = 0; i < this.countPhone.length; i++) {
        if (this.countPhone[i] !== "") {
          counter = counter + 1
        }
      }
      for (let i = 0; i < this.countMail.length; i++) {
        if (this.countMail[i] !== "") {
          counter = counter + 1
        }
      }
      for (let i = 0; i < this.countWeb.length; i++) {
        if (this.countWeb[i] !== "") {
          counter = counter + 1
        }
      }
      for (let i = 0; i < this.iconTextFields.length; i++) {
        if (this.iconTextFields[i].dataInput !== undefined && this.iconTextFields[i].dataInput !== '' && this.iconTextFields[i].dataInput !== null) {
          counter = counter + 1
        }
      }
      let infoList = []
      let cellList = []
      let phoneList = []
      let mailList = []
      let webList = []
      let socialList = []
      if (cellList.length == 0) {
        for (let i = 0; i < this.countCell.length; i++) {
          for (let j = 0; j < this.validationBoolean.length; j++) {
            if (this.countCell[i] == this.validationBoolean[j].number && this.validatePhone(this.countCell[i]) && this.countCell[i] != this.user.phone) {
              cellList.push({
                type: 'telephone',
                value: this.countCell[i]
              })
              this.lastValidation = true
            } else if (!this.validatePhone(this.countCell[i])) {
              this.$toast.error('اطلاعات را صحیح وارد کنید.')
              return
            }
          }
        }
      } else {
        for (let i = 0; i < this.countCell.length; i++) {
          for (let j = 0; j < this.validationBoolean.length; j++) {
            for (let k = 0; k < cellList.length; k++) {
              if (this.countCell[i] == this.validationBoolean[j].number &&
                  this.validatePhone(this.countCell[i]) &&
                  this.countCell[i] != this.user.phone &&
                  this.countCell[i] == cellList[k]) {
                break
              } else if (this.countCell[i] == this.validationBoolean[j].number &&
                  this.validatePhone(this.countCell[i]) &&
                  this.countCell[i] != this.user.phone &&
                  k == cellList.length - 1 &&
                  this.countCell[i] != cellList[k]) {
                cellList.push({
                  type: 'telephone',
                  value: this.countCell[i]
                })
              }
            }
          }
        }
      }
      if (cellList.length == 0) {
        this.lastValidation = false
      } else {
        for (let i = 0; i < this.countCell.length; i++) {
          for (let j = 0; j < cellList.length; j++) {
            if (cellList[j].value == this.countCell[i] && this.countCell[i] != this.user.phone) {
              break
            } else if (j == cellList.length - 1 && cellList[j].value != this.countCell[i] && this.countCell[i] != this.user.phone) {
              this.$toast.error(`شماره ${this.countCell[i]} اعتبارسنجی نشده است.`)
              this.lastValidation = false
            }
          }
        }
      }
      if (this.countCell.length == 1 && this.countCell[0] == this.user.phone) {
        this.lastValidation = true
      }
      console.log(this.countCell, this.lastValidation)
      for (let i = 0; i < this.countCell.length; i++) {
        if (this.countCell[i] == this.user.phone && this.lastValidation == true) {
          cellList.push({
            type: 'telephone',
            value: this.user.phone
          })
        }
      }
      for (let i = 0; i < this.countPhone.length; i++) {
        phoneList.push({
          type: 'phone',
          value: this.countPhone[i]
        })
      }
      for (let i = 0; i < this.countMail.length; i++) {
        if (/.+@.+\..+/.test(this.countMail[i])) {
          mailList.push({
            type: 'email',
            value: this.countMail[i]
          })
        } else if (this.countMail[i] != '') {
          this.$toast.error('اطلاعات را صحیح وارد کنید.')
          return
        }
      }
      for (let i = 0; i < this.countWeb.length; i++) {
        webList.push({
          type: 'site',
          value: this.countWeb[i]
        })
      }
      for (let i = 0; i < this.iconTextFields.length; i++) {
        if (this.iconTextFields[i].dataInput !== undefined && this.iconTextFields[i].dataInput !== '' && this.iconTextFields[i].dataInput !== null) {
          if (this.iconTextFields[i].label == 'Instagram') {
            socialList.push({
              type: 'instagram',
              value: this.iconTextFields[i].dataInput
            })
          }
          if (this.iconTextFields[i].label == 'Telegram') {
            socialList.push({
              type: 'telegram',
              value: this.iconTextFields[i].dataInput
            })
          }
          if (this.iconTextFields[i].label == 'Whatsapp') {
            socialList.push({
              type: 'whatsapp',
              value: this.iconTextFields[i].dataInput
            })
          }
          if (this.iconTextFields[i].label == 'Linkedin') {
            socialList.push({
              type: 'linkedin',
              value: this.iconTextFields[i].dataInput
            })
          }
          if (this.iconTextFields[i].label == 'Skype') {
            socialList.push({
              type: 'skype',
              value: this.iconTextFields[i].dataInput
            })
          }
          if (this.iconTextFields[i].label == 'Twitter') {
            socialList.push({
              type: 'twitter',
              value: this.iconTextFields[i].dataInput
            })
          }
          if (this.iconTextFields[i].label == 'Facebook') {
            socialList.push({
              type: 'facebook',
              value: this.iconTextFields[i].dataInput
            })
          }
          if (this.iconTextFields[i].label == 'Youtube') {
            socialList.push({
              type: 'youtube',
              value: this.iconTextFields[i].dataInput
            })
          }
        }
      }
      if (this.countCell[0] != "") {
        infoList = infoList.concat(cellList)
      }
      if (this.countPhone[0] != "") {
        infoList = infoList.concat(phoneList)
      }
      if (this.countMail[0] != "") {
        infoList = infoList.concat(mailList)
      }
      if (this.countWeb[0] != "") {
        infoList = infoList.concat(webList)
      }
      infoList = infoList.concat(socialList)
      this.userInfo = this.userInfo.concat(infoList)
      if (this.userInfo.length == 0) {
        this.lastValidation = true
      }
      console.log(this.lastValidation, this.userInfo.length, this.userInfo)
      if (counter > 10) {
        this.$toast.error("تعداد فیلدها نباید بیش از ۱۰ مورد باشد.")
        console.log(this.userInfothis.userInfo)
      } else if (this.countCell[0] == "") {
        this.$toast.error('فیلد شماره تلفن همراه نباید خالی باشد.')
        console.log(this.userInfo)
      } else if (this.lastValidation == false) {
        this.$toast.error('لطفا شماره تلفن‌های همراه و ایمیل‌های وارد شده را اعتبارسنجی کنید.')
      } else if (this.lastValidation != false) {
        this.$toast.success('اطلاعات تماس ثبت شدند.')
        this.contact = false
      }
    },
    submitForm() {

      if (this.avatar == null) {
        this.$toast.error('انتخاب عکس پروفایل اجباری است.')
        this.formSubmitted = true
        console.log(this.cName)
      }
      else if(! /(?!^\d+$)^[ آابپتثجچحخدذرزژسشصضطظعغفقکگلمنوهیئ123456789۱۲۳۴۵۶۷۸۹۰0\s]+$/.test(this.cName)){
        this.$toast.error('نام مجموعه باید تنها متشکل از اعداد فارسی و حروف باشد')
        this.formSubmitted = true
      }
      else if (this.cName == '' || this.cName == null) {
        this.$toast.error('نام مجموعه اجباری است.')
        this.formSubmitted = true
      } else if (this.cAddress == '' || this.cAddress == null) {
        this.$toast.error('وارد کردن فیلد آدرس اجباری است.')
        this.formSubmitted = true
      } else if (this.paymentContent == '') {
        this.$toast.error('مشخص کردن شرایط پرداخت اجباری است.')
        this.formSubmitted = true
      } else if (this.userInfo == '' || this.userInfo == null) {
        this.$toast.error('وارد کردن اطلاعات تماس اجباری است.')
        this.formSubmitted = true
      } else if (this.selectedFile == null) {
        this.$toast.error('آپلود مدارک اجباری است.')
        this.formSubmitted = true
      } else if (this.aboutUs == '' || this.aboutUs == null) {
        this.$toast.error('وارد کردن فیلد درباره ما اجباری است.')
        this.formSubmitted = true
      } else {
        let userRegisterInfo = new FormData()
        userRegisterInfo.append('about_logo', this.avatar.imageFile)
        userRegisterInfo.append('collection_name', this.cName)
        userRegisterInfo.append('collection_address', this.cAddress)
        userRegisterInfo.append('about_us', this.aboutUs)
        userRegisterInfo.append('billboard_documents[]', this.selectedFile)
        userRegisterInfo.append('payment_terms', this.paymentContent)
        let counter = 0;
        for (let item of this.userInfo) {
          userRegisterInfo.append(`contacts[${counter}][type]`, item.type)
          userRegisterInfo.append(`contacts[${counter++}][value]`, item.value)
        }
        // console.log(this.aboutAvatar)
        // console.log(this.cNameArray)
        // console.log(this.cAddressArray)
        // console.log(this.paymentContent)
        // console.log(this.userInfo)
        // console.log(this.selectedFile)
        // console.log(this.aboutUs)
        this.requestApiPost('userInfo', userRegisterInfo)
            .then(res => {
              console.log(res)
              this.formSubmitted = false
              this.$modal.showLoading();
              this.requestApiGet('userInfo')
                  .then(({ data }) => {
                    this.$modal.hideLoading()
                    this.getUserData = data.data
                    console.log(this.getUserData)
                    this.cName = this.getUserData.collection_name
                    this.cAddress = this.getUserData.collection_address
                    this.aboutUs = this.getUserData.about_us
                    this.userImageFile = this.getUserData.about_logo
                    // this.envAddress = process.env.VUE_APP_API_URL
                    this.userImageURL = process.env.VUE_APP_API_URL + '/storage/' + this.userImageFile
                    this.getPaymentTerms = this.getUserData.payment_terms
                    console.log(this.getUserData)
                    this.isPending()
                  })
                  .catch((err) => {
                    this.$modal.hideLoading()
                    this.$modal.error('خطا در اتصال به دیتابیس')
                    console.log(err)

                  })
            })
            .catch(err => console.log(err))
      }
    },
  }
}
</script>
<style scoped>
.btn-get-code {
  margin: 0;
}

.theme--light.v-input input,
.theme--light.v-input textarea {
  margin-top: 5px !important;
}

.v-btn:not(.v-btn--round).v-size--default {
  height: auto;
}

.alert-warn {
  background-color: #CFD8DC;
}

.v-btn:not(.v-btn--round).v-size--large {
  margin-top: 10px;
}

.inputs {
  max-width: 600px;
}

.avatar {
  cursor: pointer;
}

.switch {
  right: 0px;
  left: auto;
  position: relative;
  color: rgba(0, 0, 0, 0.6);
  line-height: 20px;
  letter-spacing: normal;
  font-size: 16px;
  min-height: 8px;
  margin-bottom: 0.5rem;
  cursor: pointer;
  margin-left: 0.5rem;
}

/* .contact-info {
    min-width: 100px !important;
    width: 600px !important;
    max-width: 600px !important;
} */

.v-application p {
  margin: 16px;
}

.v-application--wrap {
  min-height: auto;
}

.media {
  margin-top: -20px;
  padding: 0;
}

.btn i {
  font-size: 2rem;
}

.icon-card {
  min-width: 350px;
}

.btn.btn-icon {
  margin-left: 30px;
  margin-top: 30px !important;
  margin-right: 2rem;
}

.btn.btn-icon:hover .icon-text {
  display: block !important;
}

.plus-minus {
  margin-top: -8px !important;
}
</style>
